<template>
  <div
    id="exchange-container"
    :class="['exchange-container', {'background-white': theme === 'white'}]"
  >
    <div :class="['is-expanded pd-30px', {'pd-bt-0': theme === 'white'}]">
      <div :class="['is-expanded', {'color-black': theme === 'white'}]">
        {{ $t('exchange.from_token') }}
      </div>
      <div class="is-expanded">
        <div
          :class="['dropdown-box', {'border-line': theme === 'white'}]"
          @click="$emit('openSelectTokenModal', 'from')"
        >
          <div class="token-logo">
            <div v-if="fromToken.code">
              <img :src="`/static/token/normal/${fromToken.code.toLowerCase()}.svg`">
            </div>
            <div v-else>
              <b-skeleton
                width="30px"
                height="30px"
                circle
              />
            </div>
          </div>
          <div class="token-info-box">
            <div v-if="fromToken.code">
              <div class="token-code">{{ fromToken.code }}</div>
            </div>
            <div
              v-else
              class="token-code"
            >
              <b-skeleton width="40px"/>
            </div>
            <div v-if="fromToken.name">
              <div class="token-name">{{ fromToken.name }}</div>
            </div>
            <div
              v-else
              class="token-name"
            >
              <b-skeleton width="60px"/>
            </div>
          </div>
          <div class="expand-more-ic">
            <img src="/static/svg/expand-more.svg">
          </div>
        </div>
      </div>
      <div class="is-expanded">
        <b-input
          v-model="fromTokenInput"
          :class="['is-underline-input-white', {'is-underline-input-gray': theme === 'white'}]"
          :loading="inputFrom === 'LOADING'"
          :placeholder="inputFrom === 'LOADING' ? 'Loading...' : 'Enter amount'"
          type="number"
          step="0.1"
          @keyup.native="typeOnFormTokenInput"
          @wheel.native="$event.target.blur()"
        />
      </div>
      <div
        v-if="isFromAmountTooHighType === 'NOT_ENOUGH'"
        class="is-expanded amount-too-high"
      >
        {{ $t('errors.balance_not_enough') }}
      </div>
      <div
        v-else-if="isFromAmountTooHighType === 'GAS_NOT_ENOUGH'"
        class="is-expanded amount-too-high"
      >
        {{ $t('errors.eth_not_enough_for_network_fee') }}
      </div>
      <div class="is-expanded">
        <div :class="['max-balance is-dots', {'color-blue': theme === 'white'}]">
          <span @click="allIn()">
            {{ $t('exchange.max_balance') }} {{ fromToken.balance | numberWithComma }} {{ fromToken.code }}
          </span>
        </div>
      </div>
    </div>
    <div :class="['is-expanded swap-box', {'background-grey': theme === 'white'}]">
      <div
        class="swap-circle"
        @click="$emit('switchToken')"
      >
        <img src="/static/svg/swap.svg">
      </div>
    </div>
    <div :class="['is-expanded pd-30px', {'pd-t-0': theme === 'white'}]">
      <div :class="['is-expanded', {'color-black': theme === 'white'}]">
        {{ $t('exchange.to_token') }}
      </div>
      <div class="is-expanded">
        <div
          :class="['dropdown-box', {'border-line': theme === 'white'}]"
          @click="$emit('openSelectTokenModal', 'to')"
        >
          <div class="token-logo">
            <div v-if="toToken.code">
              <img :src="`/static/token/normal/${toToken.code.toLowerCase()}.svg`">
            </div>
            <div v-else>
              <b-skeleton
                width="30px"
                height="30px"
                circle
              />
            </div>
          </div>
          <div class="token-info-box">
            <div v-if="toToken.code">
              <div class="token-code">{{ toToken.code }}</div>
            </div>
            <div
              v-else
              class="token-code"
            >
              <b-skeleton width="40px"/>
            </div>
            <div v-if="toToken.name">
              <div class="token-name">{{ toToken.name }}</div>
            </div>
            <div
              v-else
              class="token-name"
            >
              <b-skeleton width="60px"/>
            </div>
          </div>
          <div class="expand-more-ic">
            <img src="/static/svg/expand-more.svg">
          </div>
        </div>
      </div>
      <div class="is-expanded">
        <b-input
          v-model="toTokenInput"
          :class="['is-underline-input-white', {'is-underline-input-gray': theme === 'white'}]"
          :loading="inputTo === 'LOADING'"
          :placeholder="inputTo === 'LOADING' ? 'Loading...' : 'Enter amount'"
          type="number"
          step="0.1"
          @keyup.native="typeOnToTokenInput"
          @wheel.native="$event.target.blur()"
        />
      </div>
      <div :class="['is-expanded rate-estimated', {'color-gray': theme === 'white'}]">
        <span v-if="bestRate[speedOfTx] && bestRate[speedOfTx].trade && bestRate[speedOfTx].trade.rate">
          {{ $t('exchange.estimate_rate') }} 1 {{ fromToken.code }} = {{ bestRate[speedOfTx].trade.rate | numberWithComma }} {{ toToken.code }}
        </span>
      </div>
    </div>
    <div :class="['advance-setting-switch-box', {'color-black': theme === 'white'}]">
      <span class="advance-setting-platform-fee">{{ $t('exchange.platform_fee') }} {{ platformFee }} %</span>
      <b-switch
        v-model="isOpenAdvancedSetting"
        :disabled="isDisableAdvSetting"
        type="is-gold"
      >
        {{ $t('exchange.advanced_setting') }}
      </b-switch>
    </div>
    <div
      v-if="isOpenAdvancedSetting && Object.keys(bestRate).length > 0"
      :class="['avd-setting-box', {'background-grey2 color-black': theme === 'white'}]"
    >
      <div :class="['avd-setting-box-content', {'avd-setting-box-content-white': theme === 'white'}]">
        <div class="my-row">
          <div class="adv-icon-img col">
            <img
              v-if="theme !== 'white'"
              src="/static/svg/icon-quick-minimum-rate.svg"
            >
            <img
              v-else
              src="/static/svg/icon-minimum-rate.svg"
            >
          </div>
          <span class="vtc-al-middle col">
            {{ $t('exchange.max_rate_change') }}
          </span>
          <span>
            <b-tooltip
              :label="$t('exchange.max_slippage_detail')"
              type="is-light"
              class="icon-info"
            >
              <img
                src="/static/svg/exchange-info.svg"
                class="price_slippage-tootip-img"
              >
            </b-tooltip>
          </span>
          <span :class="['font-title vtc-al-middle col', {'color-blue': theme === 'white'}]">
            <div class="buttons">
              <b-button
                :focused="maxPriceSlippage === 0.1"
                size="is-small"
                type="is-primary"
                outlined
                @click="maxPriceSlippage = 0.1"
              >
                0.1%
              </b-button>
              <b-button
                :focused="maxPriceSlippage === 0.5"
                size="is-small"
                type="is-primary"
                outlined
                @click="maxPriceSlippage = 0.5"
              >
                0.5%
              </b-button>
              <b-button
                :focused="maxPriceSlippage === 1"
                size="is-small"
                type="is-primary"
                outlined
                @click="maxPriceSlippage = 1"
              >
                1%
              </b-button>
              <b-button
                :focused="maxPriceSlippage === 3"
                size="is-small"
                type="is-primary"
                outlined
                @click="maxPriceSlippage = 3"
              >
                3%
              </b-button>
              <div class="price-slippage-input-wrapper">
                <input
                  v-model="priceSlippage"
                  :min="1"
                  :max="10"
                  class="price-slippage-input price-slippage-underline"
                  placeholder="Custom"
                  name="Price Slippage"
                  type="number"
                  @input="onChangePriceSlippage"
                  @wheel="$event.target.blur()"
                >
                <b-icon
                  icon="percent"
                  custom-size="mdi-15px"
                  custom-class="percent-label"
                />
              </div>
              <span
                v-if="priceSlippageInvalid"
                class="is-invalid price-invalid"
              >
                {{ $t('exchange.invalid_price_slippage_value') }}
              </span>
            </div>

          </span>
        </div>
        <div class="my-row">
          <div class="adv-icon-img col">
            <img
              v-if="theme !== 'white'"
              src="/static/svg/icon-quick-transaction-fee.svg"
            >
            <img
              v-else
              src="/static/svg/icon-transaction-fee.svg"
            >
          </div>
          <span class="vtc-al-middle col">
            {{ $t('exchange.network_fee') }} ~ <span :class="{'color-blue': theme === 'white'}">{{ txFee | numberWithComma }} </span> ETH
          </span>
          <div>
            <b-tooltip
              :label="$t('exchange.network_fee_detail')"
              type="is-light"
              class="icon-info"
            >
              <img
                src="/static/svg/exchange-info.svg"
                class="network-fee-tootip-img"
              >
            </b-tooltip>
          </div>
        </div>
        <div class="my-row">
          <div class="adv-icon-img col">
            <img
              v-if="theme !== 'white'"
              src="/static/svg/icon-quick-estimate-time.svg"
            >
            <img
              v-else
              src="/static/svg/icon-estimate-time.svg"
            >
          </div>
          <span class="vtc-al-middle col">
            {{ $t('exchange.estimate_time') }}
            <span v-if="speedOfTx === 'SLOW'"> &#60; 30 </span>
            <span v-if="speedOfTx === 'STD'"> &#60; 5 </span>
            <span v-if="speedOfTx === 'FAST'"> &#60; 2 </span>
            {{ $t('exchange.minutes') }}
          </span>
        </div>
        <div class="my-row">
          <div class="adv-icon-img col">
            <img
              v-if="theme !== 'white'"
              src="/static/svg/icon-quick-platform-fee.svg"
            >
            <img
              v-else
              src="/static/svg/icon-platform-fee-black.svg"
            >
          </div>
          <span class="vtc-al-middle col">
            {{ $t('exchange.platform_fee') }}  <span :class="{'color-blue': theme === 'white'}">{{ platformFee | numberWithComma(3) }} </span> %
          </span>
          <div>
            <b-tooltip
              :label="$t('exchange.platform_fee_detail')"
              type="is-light"
              class="icon-info"
            >
              <img
                src="/static/svg/exchange-info.svg"
                class="network-fee-tootip-img"
              >
            </b-tooltip>
          </div>
        </div>
        <div class="my-row-btn">
          <a
            :class="['extra-top-mg', { 'speed-tx-btn-active': speedOfTx === 'SLOW', 'speed-tx-btn': speedOfTx !== 'SLOW' }]"
            @click="speedOfTx = 'SLOW'"
          >
            {{ $t('exchange.slow') }}
          </a>
          <a
            :class="['extra-top-mg', { 'speed-tx-btn-active': speedOfTx === 'STD', 'speed-tx-btn': speedOfTx !== 'STD' }]"
            @click="speedOfTx = 'STD'"
          >
            {{ $t('exchange.standard') }}
          </a>
          <a
            :class="['extra-top-mg', { 'speed-tx-btn-active': speedOfTx === 'FAST', 'speed-tx-btn': speedOfTx !== 'FAST' }]"
            @click="speedOfTx = 'FAST'"
          >
            {{ $t('exchange.fast') }}
          </a>
        </div>
      </div>
    </div>
    <div class="is-expanded pd-30px">
      <div
        :class="['exchange-btn', {
          'background-blue color-white exchange-btn-white': theme === 'white',
          'disabled-exchange-btn': !isCanExchange
        }]"
        data-test="exchange--exchange-btn"
        @click="clickExchange()"
      >
        {{ $t('exchange.exchange_token') }}
      </div>
    </div>
  </div>
</template>

<script>
import bignumber from '@/utils/bignumber'
import { BIGNUMBER_ZERO, DEFAULT_PRICE_SLIPPAGE, PLATFORM_FEE } from '@/constants'

export default {
  name: 'Exchange',
  props: {
    inputFrom: {
      type: [Number, String],
      default: 0
    },

    inputTo: {
      type: [Number, String],
      default: 0
    },

    /**
     * theme: `blue`, `white`
     */
    theme: {
      type: String,
      default: 'blue'
    },
    /**
     * fromToken: {
     *  code,
     *  name,
     *  balance
     * }
     */
    fromToken: {
      type: Object,
      required: true
    },
    /**
     * toToken: {
     *  code,
     *  name,
     *  balance
     * }
     */
    toToken: {
      type: Object,
      required: true
    },
    /**
     * bestRate: {
     *  FAST: {
     *    gasPrice,
     *    gasLimit
     *  },
     *  STD: { ... },
     *  SLOW: { ... }
     * }
     */
    bestRate: {
      type: Object,
      required: true
    },
    isFromAmountTooHighType: {
      type: String, // ENUM: ['NOT_ENOUGH', 'GAS_NOT_ENOUGH', 'ENOUGH']
      required: true
    }
  },
  data () {
    return {
      fromTokenInput: this.inputFrom && !isNaN(this.inputFrom) ? bignumber(this.inputFrom).toString() : null,
      toTokenInput: this.inputTo && !isNaN(this.inputTo) ? bignumber(this.inputTo).toString() : null,
      speedOfTx: 'STD',
      priceSlippage: null,
      maxPriceSlippage: DEFAULT_PRICE_SLIPPAGE,
      platformFee: PLATFORM_FEE,
      isOpenAdvancedSetting: false
    }
  },
  computed: {
    txFee () {
      if (this.bestRate[this.speedOfTx]) {
        let gasUsed = bignumber(this.bestRate[this.speedOfTx].gasPrice.gweiToWei().multipliedBy(this.bestRate[this.speedOfTx].gasLimit))
        return gasUsed.toBase().toString()
      } else {
        return 0
      }
    },
    gasLimit () {
      if (this.bestRate[this.speedOfTx]) {
        return this.bestRate[this.speedOfTx].gasLimit
      } else {
        return 0
      }
    },
    isCanExchange () {
      return this.isFromAmountTooHighType === 'ENOUGH' &&
      this.bestRate && this.bestRate[this.speedOfTx] &&
      this.bestRate[this.speedOfTx].trade &&
      bignumber(this.fromTokenInput).isGreaterThan(BIGNUMBER_ZERO) &&
      !this.priceSlippageInvalid
    },
    isDisableAdvSetting () {
      return !this.isCanExchange
    },
    priceSlippageInvalid () {
      if (this.maxPriceSlippage >= 0 && this.maxPriceSlippage <= 10) {
        return false
      }
      return true
    }
  },
  watch: {
    isFromAmountTooHighType (val) {
      if (val === 'NOT_ENOUGH' || val === 'GAS_NOT_ENOUGH') {
        this.isOpenAdvancedSetting = false
      }
    },
    bestRate (val) {
      if (Object.keys(val).length === 0) {
        this.isOpenAdvancedSetting = false
        // this.$emit('clearAllData')
      } else if (Object.keys(val).length !== 3) {
        if (val['STD']) this.speedOfTx = 'STD'
        else if (val['FAST']) this.speedOfTx = 'FAST'
        else if (val['SLOW']) this.speedOfTx = 'SLOW'
      }
    },
    speedOfTx (val) {
      this.$emit('changeSpeedOfTx', val)
    },
    inputFrom (value) {
      if (value !== this.fromTokenInput) {
        this.fromTokenInput = this.inputFrom && !isNaN(this.inputFrom) ? bignumber(value).toString() : null
      }
    },
    inputTo (value) {
      if (value !== this.toTokenInput) {
        this.toTokenInput = this.inputTo && !isNaN(this.inputTo) ? bignumber(value).toString() : null
      }
    }
  },
  methods: {
    typeOnFormTokenInput (event) {
      this.$emit('typeOnFormTokenInput', this.fromTokenInput)
    },
    typeOnToTokenInput () {
      this.$emit('typeOnToTokenInput', this.toTokenInput)
    },
    clickExchange () {
      if (this.isCanExchange) {
        let estimatedTime = ''
        if (this.speedOfTx === 'FAST') {
          estimatedTime = '2'
        } else if (this.speedOfTx === 'STD') {
          estimatedTime = '5'
        } else {
          estimatedTime = '30'
        }
        const data = {
          from: {
            ...this.fromToken,
            amount: this.fromTokenInput || 0
          },
          to: {
            ...this.toToken,
            amount: this.toTokenInput || 0
          },
          rate: this.bestRate[this.speedOfTx],
          txFee: bignumber(this.txFee),
          maxPriceSlippage: this.maxPriceSlippage,
          estimatedTime
        }
        this.$emit('exchange', data)
      }
    },
    allIn () {
      this.fromTokenInput = bignumber(this.fromToken.balance).toString()
      this.$emit('typeOnFormTokenInput', this.fromTokenInput)
    },
    onChangePriceSlippage () {
      if (this.priceSlippage != null) {
        this.maxPriceSlippage = bignumber(this.priceSlippage).decimalPlaces(2).toNumber()
      }
    }
  }
}
</script>

<style lang="scss">
  #exchange-container {
    .avd-setting-box-content {
      .button.is-primary.is-outlined {
        color: white;
      }
      .price-slippage-input-wrapper {
        width: fit-content;
        margin-bottom: auto;
      }
      .price-slippage-input {
        width: 77px;
        background-color: #2378b9;
        border-style: solid;
        border-color: #209cee;
        border-width: 1px;
        border-radius: 3px;
        color: white;
        height: 28px;
        margin: 0 8px 8px;
        padding: 0 9px;
        font-size: 12px;
        &::placeholder {
          color: white !important;
        }
      }
      .input::placeholder {
        color: white !important;
      }
      .input:focus {
        border-color: white !important;
      }
      .price-invalid {
        color: #ff6363;
        font-size: 12px;
      }
    }
    .avd-setting-box-content-white {
      .button.is-primary {
        &.is-outlined {
          color: black;
          border-color: #d2cfcf;
          &:focus {
            background-color: #52baff;
            color: white;
          }
          &.is-focused {
            color: white;
          }
        }
      }
      .price-slippage-input {
        width: 77px;
        background-color: #f6f6f6;
        border-color: #d2cfcf;
        color: black;
        height: 28px;
        margin: 0 8px 8px;
        font-size: 12px;
        &::placeholder {
          color: black !important;
        }
      }
      .input::placeholder {
        color: black !important;
      }
      .input:focus {
        border-color: black !important;
        background-color: #52baff;
        color: white;
      }
      .price-invalid {
        color: red;
        font-size: 12px;
      }
    }
    .percent-label {
      margin: 0 0 5px;
    }

    @media screen and (max-width: 768px) {
      .avd-setting-box-content {
        .price-slippage-input {
          margin: unset;
        }
      }
      .avd-setting-box-content-white {
        .price-slippage-input {
          margin: unset;
        }
      }
      .percent-label {
        margin: 0 0 0 5px;
      }
    }
  }
</style>

<style scoped lang="scss">
.exchange-container {
  float: left;
  width: 100%;
  border-radius: 3px;
  background-color: #0559af;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  color: #fff;
}
.is-underline-input-white-div {
  padding-bottom: 3px !important;
  background: transparent !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  border-bottom: 1px solid #fff !important;
  border-color: #fff !important;
  color: #fff !important;
  opacity: 1 !important;
}
.is-underline-input-gray-div {
  border-bottom: 1px solid #bcbcbc !important;
  color: gray !important;
  opacity: 1 !important;
}
.is-underline-input-white-div:hover {
  cursor: not-allowed;
}
.pd-30px {
  padding: 30px;
}
.pd-t-0 {
  padding-top: 0px
}
.pd-bt-0 {
  padding-bottom: 0px
}
.dropdown-box {
  margin-top: 20px;
  margin-bottom: 25px;
  float: left;
  width: 100%;
  border-radius: 2px;
  background-color: #ffffff;
  padding: 5px 9px;
  color: #000;
  cursor: pointer;
}
.border-line {
  border: solid 1px #dfdfdf;
}
.token-logo {
  width: 30px;
  height: 30px;
  float: left;
  margin-right: 7px;
  img {
    max-height: 30px;
  }
}
.token-info-box {
  float: left;
}
.token-code {
  font-size: 13px;
  font-weight: 600;
  line-height: 13px;
  margin: 1px 0;
}
.token-name {
  font-size: 13px;
  line-height: 13px;
}
.expand-more-ic {
  float: right;
  margin-right: 10px;
  padding-top: 4px;
}
.max-balance {
  margin-top: 15px;
  float: right;
  text-align: right;
  width: 100%;
  text-decoration: underline;
  cursor: pointer;
  font-family: DINAlternate !important;
  font-size: 13px;
}
.rate-estimated {
  margin-top: 15px;
  float: right;
  text-align: right;
  width: 100%;
  cursor: pointer;
  font-family: DINAlternate !important;
  font-size: 13px;
}
.swap-box {
  height: 1px;
  background-color: #fff;
  position: relative;
  margin: 50px 0 30px 0;
}

.swap-circle {
  width: 58px;
  height: 58px;
  background-color: #ffcf00;
  border: solid 1px #ffffff;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: -29px;
  transform: translate(-50%);
  text-align: center;
  padding-top: 19px;
  cursor: pointer;
}
.advance-setting-switch-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 30px 30px 0 30px;
  font-weight: bold;
  text-align: right;
  .advance-setting-platform-fee {
    font-size: 13px;
  }
}
.exchange-btn {
  padding: 11px;
  font-weight: bold;
  border-radius: 2px;
  border: solid 2px #ffffff;
  text-align: center;
  float: left;
  width: 100%;
  cursor: pointer;
}
.exchange-btn:hover {
  background-color: #fff;
  color: #0559af;
}
.avd-setting-box {
  float: left;
  width: 100%;
  background-color: #2378b9;
  padding: 30px 15px 10px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}
.t-al-left {
 text-align: left;
}
.t-al-center {
  text-align: center;
}
.t-al-right {
  text-align: right;
}
.font-title {
  font-family: DINAlternate !important;
  font-size: 17px;
  font-weight: bold;
}
.vtc-al-middle {
  vertical-align: middle;
  font-weight: 700;
}
.cs-pointer {
 cursor: pointer;
}
.mg-bt-20px {
  margin-bottom: 20px;
}
.mg-t-20px {
  margin-top: 20px;
}
.speed-tx-btn {
  float: left;
  width: 30%;
  padding: 8px;
  text-align: center;
  background-color: #b9b9b9;
  opacity: 0.3;
  border-radius: 20px;
  color: #070707;
}
.speed-tx-btn:hover {
  opacity: 0.6;
  background-color: #0559af;
  color: #fff;
}
.speed-tx-btn-active {
  float: left;
  width: 30%;
  padding: 8px;
  text-align: center;
  border-radius: 20px;
  background-color: #0559af;
  color: #fff;
}
.f-s-13px {
  font-size: 13px
}
.color-blue {
  color: #0096ed;
}
.color-gray {
  color: #666666;
}
.color-white {
  color: #ffffff;
}
.color-black {
  color: #000000;
}
.color-red {
  color: red;
}
.background-white {
  background-color: #ffffff;
  border-radius: 0;
}
.background-blue {
  background-color: #0559af;
}
.background-grey {
  background-color: #dfdfdf;
}
.background-grey2 {
  background-color: #f6f6f6;
}
.exchange-btn-white {
  border-radius: 5px;
}
.exchange-btn-white:hover {
  border: solid 1px #0559af;
}
.amount-too-high {
  color: #ff7d40;;
  margin-top: 5px;
  font-weight: bold;
  font-size: 14px;
}
.disabled-exchange-btn {
  cursor: not-allowed;
}
.adv-icon-img {
  float: left;
  width: 15px;
}
.extra-top-mg {
  margin-top: 20px;
}
.my-row {
  width: 100%;
  float: left;
  margin: 10px 12%;
}
.my-row-btn {
  width: 100%;
  float: left;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin: 10px 0;
}
.col {
  float: left;
  margin: 6px 5px 0px;
}
.avd-setting-box-content {
  width: 70%;
}
.avd-setting-box-content-white {
  width: 85%;
}
.f-right {
  float: right;
}
.price_slippage-tootip-img {
  margin-left: 4px;
  margin-top: 7px;
}
.network-fee-tootip-img {
  margin-left: 4px;
  margin-top: 5px;
}
@media only screen and (max-width: 1430px) {
  .avd-setting-box-content {
    width: 70%;
  }
  .avd-setting-box-content-white {
    width: 85%;
  }
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  .avd-setting-box {
    padding: 30px;
  }
  .my-row {
    margin: 10px 0;
    padding: 0px 10%;
  }
}

@media only screen and (max-width: 1087px) {
  .my-row {
    margin: 10px 0;
    padding: 0px 8%;
  }
}
@media only screen and (max-width: 768px) {
  .exchange-container {
    box-shadow: unset;
  }
  .advance-setting-switch-box {
    padding: 0px 30px 0 30px;
    .advance-setting-platform-fee {
      font-size: 12px;
    }
  }
  .avd-setting-box div {
    text-align: center;
  }
  .avd-setting-box {
    float: left;
    padding: 20px 0;
  }
  .avd-setting-box-content {
    width: 80%;
  }
  .my-row {
    padding: 0px 10%;
  }
  .my-row-btn {
    margin: 10px 0;
    padding: 0px 20px;
  }
  .avd-setting-box-content-white {
    width: 85%;
  }
}
@media only screen and (max-width: 604px) {
  .avd-setting-box-content {
    width: 90%;
  }
  .avd-setting-box-content-white {
    width: 95%;
  }
}
/* Mobile */
@media only screen and (max-width: 540px) {
  .avd-setting-box div {
    text-align: center;
  }
  .avd-setting-box {
    float: left;
    padding: 20px 0;
  }
  .avd-setting-box-content {
    width: 100%;
  }
  .my-row {
    padding: 0px 10%;
    margin: 10px 0;
  }
}
@media only screen and (max-width: 320px) {
  .my-row {
    padding: 0px 8%;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Exchange.vue